export const PLAN_ROUTE_COLOR = '#8B008B';
export const ACTUAL_ROUTE_COLOR = '#067ec1';
export const CIRCLE_COLOR = '#056093';



// WEBPACK FOOTER //
// ./resources/js/maps/config.js